import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-virtual-num-pad',
	templateUrl: './virtual-num-pad.component.html',
	styleUrls: ['./virtual-num-pad.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class VirtualNumPadComponent implements OnInit, OnChanges {

	@Input() twoDigitsPass = true;
	@Input() hasCorrect = true;
	@Input() hasOk = true;
	@Input() isTransactionUser = true;
	@Input() disabled = false;
	@Input() inputText: any;
	@Input() shuffle: boolean;
	@Output() changeValue: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();
	@Output() correctValue: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() setInputTarget: EventEmitter<string> = new EventEmitter<string>();

	public nums: Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

	constructor() {
		this.shuffle = true;
	}

	ngOnInit() {
		this.setOrderNums();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if ((changes.inputText) && (changes.inputText.currentValue !== changes.inputText.previousValue)) {
			this.setOrderNums();
		}
	}

	setOrderNums() {
		if (this.shuffle) {
			this.nums = this.nums.map((a) => [Math.random(), a]).sort((a, b) => a[0] - b[0]).map((a) => a[1]);
		} else {
			this.nums = this.placeZerosAtEnd(this.nums.sort());
		}
	}

	placeZerosAtEnd(arr: Array<number>) {
		for (let i = 0; i < arr.length ; i++) {
			if (arr[i] === 0) {
				arr.splice(arr.length - 1, 0, arr.splice(i, 1)[0]);
			}
		}
		return arr;
	}

	getNumber(number1: number, number2: number) {
		this.changeValue.emit([number1, number2]);
	}

	correct() {
		this.correctValue.emit(true);
	}

	changeInputTarget() {
		this.setInputTarget.emit('CHANGE_INPUT_TARGET');
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/virtual-num-pad/virtual-num-pad.component.ts